/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-block.col-md-3[_ngcontent-%COMP%]   .block-small[_ngcontent-%COMP%]   .block-small_content[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:1px}"];
export { styles as styles };
